import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IAward } from '../eventAwards/store';
import { IAdminEventAwardsStore } from './store';

export type ICreateEventAwardsAction = (
  clubId: number,
  eventId: number,
  data: any,
  force?: boolean
) => { adminEventAwards?: IAdminEventAwardsStore; errors?: IErrorsStore };

export type IDeleteEventAwardsAction = (
  clubId: number,
  eventId: number,
  awardId: number
) => { adminEventAwards?: IAdminEventAwardsStore; errors?: IErrorsStore };

export type IUpdateEventAwardsAction = (
  clubId: number,
  eventId: number,
  awardId: number,
  award: Partial<IAward>
) => { adminEventAwards?: IAdminEventAwardsStore; errors?: IErrorsStore };

export interface IAdminEventAwardsActions extends IActionGroup {
  create: ICreateEventAwardsAction;
  delete: IDeleteEventAwardsAction;
  get: (
    clubId: number,
    eventId: number,
    force?: boolean
  ) => { adminEventAwards?: IAdminEventAwardsStore; errors?: IErrorsStore };
  update: IUpdateEventAwardsAction;
}

const actions: IActionGroup = {
  create: async (state: IStore, clubId: number, eventId: number, data: any) => {
    const response = await request.post(api.admin.eventAwards(clubId, eventId), data);

    if (response.error) {
      return {
        errors: { adminEventAwards: { msg: response.error.statusText } }
      };
    }

    return {
      adminEventAwards: {
        ...state.adminEventAwards,
        [eventId]: {
          ...state.adminEventAwards[eventId],
          [response.id]: response
        }
      }
    };
  },
  delete: async (
    state: IStore,
    clubId: number,
    eventId: number,

    awardId: number
  ) => {
    const response = await request.delete(api.admin.eventAward(clubId, eventId, awardId));

    if (response.error) {
      return {
        errors: { adminEventAwards: { msg: 'Error removing the Event Awards.' } }
      };
    }

    const roundAwards = state.adminEventAwards[eventId];

    delete roundAwards[awardId];

    return {
      adminEventAwards: {
        ...state.adminEventAwards,
        [eventId]: roundAwards
      }
    };
  },
  get: async (state: IStore, clubId: number, eventId: number, force?: boolean) => {
    if (state.adminEventAwards[eventId] && state.adminEventAwards[eventId] && !force) {
      return {
        adminEventAwards: state.adminEventAwards
      };
    }

    const response = await request.get(api.admin.eventAwards(clubId, eventId));

    if (response.error) {
      return {
        errors: { adminEventAwards: { msg: 'Error retrieving the Event Awards List.' } }
      };
    }

    return {
      adminEventAwards: {
        ...state.adminEventAwards,
        [eventId]: {
          ...response.reduce(
            (acc: IAdminEventAwardsStore, award: IAward) => ({
              ...acc,
              [award.id]: award
            }),
            {}
          )
        }
      }
    };
  },
  update: async (
    state: IStore,
    clubId: number,
    eventId: number,

    awardId: number,
    award: Partial<IAward>
  ) => {
    const response = await request.patch(api.admin.eventAward(clubId, eventId, awardId), award);

    if (response.error) {
      return {
        errors: {
          adminEventAwards: {
            msg: 'Can`t update the award.'
          }
        }
      };
    }

    return {
      adminEventAwards: {
        ...state.adminEventAwards,
        [eventId]: {
          ...state.adminEventAwards[eventId],
          [response.id]: response
        }
      }
    };
  }
};

export default actions;
